import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { graphql } from 'react-apollo';
import PropTypes from 'prop-types';
import moment from 'moment';
import withStyles from '@material-ui/core/styles/withStyles';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { FaSave } from 'react-icons/fa';

import GridItem from '../../../components/Grid/GridItem';
import GridContainer from '../../../components/Grid/GridContainer';
import Card from '../../../components/Card/Card';
import CardHeader from '../../../components/Card/CardHeader';
import CardBody from '../../../components/Card/CardBody';
import Button from '../../../components/CustomButtons/Button';
import { Dialog } from '../../../components';
import { createLeaderboard } from './mutations';
import styles from './styles';

/**
 * datetime-local → Eastern wall-clock string for API.
 * Server converts America/New_York → UTC (with DST).
 */
const toServerDateTime = (value) => {
  if (!value) return '';
  const parsed = moment(value, 'YYYY-MM-DDTHH:mm', true);
  return parsed.isValid() ? parsed.format('MM/DD/YYYY HH:mm:ss') : '';
};

class AddLeaderboard extends Component {
  state = {
    name: '',
    periodFrom: '',
    periodTo: '',
    isAdded: false,
    open: false,
    title: '',
    content: '',
    saving: false,
  };

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  onSubmit = async () => {
    const { name, periodFrom, periodTo } = this.state;
    const { createLeaderboard: createMutation } = this.props;

    if (!name || !periodFrom || !periodTo) {
      this.setState({
        open: true,
        title: 'Add Leaderboard',
        content: 'Name, Period From and Period To are required.',
      });
      return;
    }

    this.setState({ saving: true });
    try {
      await createMutation({
        variables: {
          input: {
            name,
            periodFrom: toServerDateTime(periodFrom),
            periodTo: toServerDateTime(periodTo),
          },
        },
      });
      this.setState({ saving: false, isAdded: true });
    } catch (error) {
      const message = error && error.graphQLErrors && error.graphQLErrors[0]
        ? error.graphQLErrors[0].message
        : 'Failed to create leaderboard';
      this.setState({
        saving: false,
        open: true,
        title: 'Add Leaderboard',
        content: message,
      });
    }
  };

  render() {
    const { classes } = this.props;
    const {
      name, periodFrom, periodTo, isAdded, open, content, title, saving,
    } = this.state;

    return (
      <GridContainer justify="center" alignItems="center">
        {isAdded ? <Redirect to="/leaderboards" /> : null}
        <Dialog
          title={title}
          content={content}
          open={open}
          onOk={() => this.setState({ open: false })}
        />
        <GridItem xs={10} sm={8} md={6}>
          <Card>
            <CardHeader>Add Leaderboard</CardHeader>
            <CardBody>
              <TextField
                label="Name"
                name="name"
                value={name}
                onChange={this.handleChange}
                fullWidth
                className={classes.field}
              />
              <TextField
                label="Period From (Eastern Time)"
                name="periodFrom"
                type="datetime-local"
                value={periodFrom}
                onChange={this.handleChange}
                fullWidth
                className={classes.field}
                helperText="America/New_York — enter Miami/OH wall-clock time (DST applied on server)"
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                label="Period To (Eastern Time)"
                name="periodTo"
                type="datetime-local"
                value={periodTo}
                onChange={this.handleChange}
                fullWidth
                className={classes.field}
                InputLabelProps={{ shrink: true }}
              />
              <Button
                variant="contained"
                color="primary"
                className={classes.button}
                onClick={this.onSubmit}
                disabled={saving}
              >
                <Typography component="p" className={classes.textEdit}>
                  {saving ? 'Saving...' : 'Save'}
                </Typography>
                <FaSave color="#ffffff" size={16} />
              </Button>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }
}

AddLeaderboard.propTypes = {
  classes: PropTypes.object,
  createLeaderboard: PropTypes.func,
};

AddLeaderboard.defaultProps = {
  classes: {},
  createLeaderboard: () => {},
};

export default withStyles(styles)(graphql(createLeaderboard, { name: 'createLeaderboard' })(AddLeaderboard));
